<p-card [header]="'serviceDlp.gridStatusDashboard.alarms.title' | translate">
  <p-messages
    [value]="alarms()"
    [enableService]="false"
    [closable]="false"
    [hideTransitionOptions]="'0ms'"
    [showTransitionOptions]="'0ms'"
  ></p-messages>
</p-card>
